import { Http } from "../../../support";

export const initialState = {
  busy: false,
  data: {},
  progress: 0,
  result: undefined,
  error: undefined,
}

const reset = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.upload = { ...initialState };
  });
}

const onChange = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.upload.data = {
      ...state.modulo.timbrado_masivo.upload.data,
      ...data
    };
  });
}

const progress = (store, progress) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.upload.progress = progress;
  });
}

const upload = async (store, onUploadProgress = () => { }) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.upload.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    };

    const { data } = store.state.modulo.timbrado_masivo.upload;

    let formData = new FormData();

    formData.append('file', data.file);
    formData.append('tipo', data.tipo);
    formData.append('fallback', data.fallback || false);

    const response = await Http.post(`${window.BONJOUR_URL}/api/timbrado-masivo/comprobantes`, formData, options);

    store.setState((state) => {
      state.modulo.timbrado_masivo.upload.progress = 100;
      state.modulo.timbrado_masivo.upload.busy = false;
      state.modulo.timbrado_masivo.upload.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_masivo.upload.busy = false;
      state.modulo.timbrado_masivo.upload.error = error.data || error;
    });
  }
}

const TimbradoMasivoUploadStore = ({
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    upload
  }
});

export default TimbradoMasivoUploadStore;